import { Constants } from '@/cfg/constants';
import TermsInc from '@/components/includes/TermsInc.vue';
import TermsIncUk from '@/components/includes/TermsIncUk.vue';

// Terms of Service text differs per region; consumers import this instead of a specific TermsInc.
export default Constants.REGION === 'uk' ? TermsIncUk : TermsInc;
